import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getIssues = createAsyncThunk('/getIssues', async () => {
  const response = await axios.get(`/GetIssues`);
  return response.data;
});

export const getIssueDetails = createAsyncThunk(
  '/getIssueDetails',
  async (id) => {
    const response = await axios.get(`/GetIssueDetails/${id}`);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get(`/GetLanguageList`);
    return response.data;
  }
);

export const getIssueTypeList = createAsyncThunk('/getIssueTypeList', async () => {
  const response = await axios.get(`/GetIssueTypeList`);
  return response.data;
});

export const setCatalogItem = createAsyncThunk(
  '/SetCatalogItem',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetCatalogItem',
      data
    );
    return response.data;
  }
);

export const getTenantList = createAsyncThunk('/getTenantList', async () => {
  const response = await axiosHeadOffice.get('/Technician/GetTenantList');
  return response.data;
});

export const getIssuesForCustomerFeedback = createAsyncThunk('/getIssuesForCustomerFeedback', async () => {
  const response = await axios.get(`/GetIssuesForCustomerFeedback`);
  return response.data;
});


const issueSlice = createSlice({
  name: 'issue',
  initialState: {
    selectedItemId: 0,
    loading: false,
    error: '',
    Issues: [],
    Tenants: [],
    IssueDescriptions: [],
    IssueTypeList: [],
    IssueType: '',
    IssueTypeId: 0,
    SelectedAppTranslationId: 0,
    IsChecked: true,
    IssuesForCustomerFeedback: [],
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeselectedItemId(state, action) {
      state.selectedItemId = action.payload;
    },
    resetDescriptions(state) {
      state.IssueDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeTenants(state, action) {
      state.Tenants = action.payload;
    },
    changeIssueType(state, action) {
      state.IssueType = action.payload;
    },
    changeIssueTypeId(state, action) {
      state.IssueTypeId = action.payload;
    },
  },
  extraReducers: {
    [getIssues.pending]: state => {
      state.loading = true;
    },
    [getIssues.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getIssues.fulfilled]: (state, action) => {
      state.Issues = action.payload;
      state.loading = false;
    },
    [getIssueDetails.pending]: state => {
      state.loading = true;
    },
    [getIssueDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getIssueDetails.fulfilled]: (state, action) => {
      state.IssueDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: state => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.IssueDescriptions = action.payload;
      state.loading = false;
    },
    [getIssueTypeList.pending]: state => {
      state.loading = true;
    },
    [getIssueTypeList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getIssueTypeList.fulfilled]: (state, action) => {
      state.IssueTypeList = action.payload;
      state.loading = false;
    },
    [setCatalogItem.pending]: (state) => {
      state.loading = true;
    },
    [setCatalogItem.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setCatalogItem.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [getTenantList.pending]: (state) => {
      state.loading = true;
    },
    [getTenantList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTenantList.fulfilled]: (state, action) => {
      state.Tenants = action.payload;
      state.loading = false;
    },
    [getIssuesForCustomerFeedback.pending]: state => {
      state.loading = true;
    },
    [getIssuesForCustomerFeedback.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getIssuesForCustomerFeedback.fulfilled]: (state, action) => {
      state.IssuesForCustomerFeedback = action.payload;
      state.loading = false;
    }
  }
});

export const issueActions = issueSlice.actions;

export default issueSlice;
